<template>
  <mv-default-row>

    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-text>
            <v-list two-line subheader color="transparent">
              <v-subheader>Новости</v-subheader>
              <v-list-tile ripple v-for="item in newsarticles" :key="item.id"
              @click="() => open(item)">
                <v-list-tile-content>
                  <v-list-tile-title>{{item.title}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{item.date}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action class="hidden-sm-and-down">
                  <v-icon color="grey lighten-1">info</v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile avatar @click="add()">
                <v-list-tile-sub-title>показать более поздние</v-list-tile-sub-title>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
        <v-layout row justify-center>
          <v-dialog v-model="dialog" max-width="1000">
            <v-card v-if="show">
              <v-toolbar flat>
                {{show.title}}
                <v-spacer></v-spacer>
                <v-btn flat icon @click="close">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-subheader>{{show.date}}</v-subheader>
              <v-subheader v-show="show.description && show.description !== ' '">{{show.description}}</v-subheader>
              <v-card-text v-html="show.content"></v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn ref="newsarticlesend" color="primary" flat @click.native="close">Закрыть</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-flex>
    </v-layout>
  </mv-default-row>
</template>

<script>

export default {
  name: 'FreshNews',
  props: [ 'newsarticles' ],
  data: () => ({
    dialog: false,
    show: null
  }),
  methods: {
    open (item) {
      this.show = item
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    add () {
      this.$emit('addMoreNews')
    }
  }
}
</script>

<style lang="css">
</style>
